import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AgentToolsState,
  AgentTool,
  AgentToolsListData,
} from '../../types/agentTools.types';

const initialState: AgentToolsState = {
  tools: [],
  selectedTool: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const agentToolsSlice = createSlice({
  name: 'agentTools',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTools: (state, action: PayloadAction<AgentToolsListData>) => {
      state.tools = action.payload.tools;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedTool: (state, action: PayloadAction<AgentTool | null>) => {
      state.selectedTool = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedTool: (state) => {
      state.selectedTool = null;
    },
    updateTool: (state, action: PayloadAction<AgentTool>) => {
      const index = state.tools.findIndex((t) => t.id === action.payload.id);
      if (index !== -1) {
        state.tools[index] = action.payload;
      }
      if (state.selectedTool?.id === action.payload.id) {
        state.selectedTool = action.payload;
      }
    },
    resetAgentTools: () => initialState,
  },
});

export const {
  setLoading,
  setError,
  setTools,
  setSelectedTool,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedTool,
  updateTool,
  resetAgentTools,
} = agentToolsSlice.actions;

export default agentToolsSlice.reducer;
